export const PRIVATE_FILE_SURFACES_ENABLED =
  import.meta.env.VITE_PRIVATE_FILE_SURFACES_ENABLED === 'true';

// Development keeps the complete phone-first registration path available so
// the flow can be exercised locally. Production and preview builds remain
// fail-closed unless the release explicitly supplies the capability flags.
export const SMS_AUTH_ENABLED =
  import.meta.env.VITE_SMS_AUTH_ENABLED === 'true' ||
  (import.meta.env.VITE_SMS_AUTH_ENABLED === undefined && import.meta.env.DEV);

export const SMS_NOTIFICATIONS_ENABLED =
  import.meta.env.VITE_SMS_NOTIFICATIONS_ENABLED === 'true';

// Money realtime is a release-gated convergence enhancement. It remains
// fail-closed until the server-side recipient-authorization controls and
// release evidence have been accepted.
export const MONEY_REALTIME_ENABLED =
  import.meta.env.VITE_MONEY_REALTIME_ENABLED === 'true';

export type RegistrationMode = 'disabled' | 'invite_only' | 'public';

export function resolveRegistrationMode(value: string | undefined): RegistrationMode {
  if (value === undefined && import.meta.env.DEV) return 'public';
  return value === 'invite_only' || value === 'public' ? value : 'disabled';
}

export const REGISTRATION_MODE = resolveRegistrationMode(
  import.meta.env.VITE_REGISTRATION_MODE,
);

export const REGISTRATION_ENABLED =
  REGISTRATION_MODE !== 'disabled' && SMS_AUTH_ENABLED;

export const INVITE_ONLY_REGISTRATION_ENABLED =
  REGISTRATION_MODE === 'invite_only' && SMS_AUTH_ENABLED;

export const PUBLIC_REGISTRATION_ENABLED =
  REGISTRATION_MODE === 'public' && SMS_AUTH_ENABLED;
